import { authAPI, getUser, setUser, removeUser } from './api';
export { authAPI, getUser, setUser, removeUser };
export default authAPI;
